import React from 'react'
import { Card, CardContent, Typography, Grid } from '@material-ui/core'
import { Skeleton } from '@mui/material'
import { isModuleEnabled } from '../config/permissions-registry'

const TILE_SIZE = 105

function FormCard ({ icon, title, link, history }) {
  return (
    <Card
      className='homeTile'
      onClick={() => history.push(`/${link}`)}
    >
      <CardContent
        className='absoluteCenter'
        style={{ textAlign: 'center', padding: '4px', width: '100%' }}
      >
        {icon}
        <Typography color='textSecondary' style={{ fontSize: '13px', lineHeight: 1.3 }}>
          {title}
        </Typography>
      </CardContent>
    </Card>
  )
}

function CardGroup ({ tiles, allowPage, history, title }) {
  const groupTiles = tiles.filter(p => allowPage(p.link))
  if (groupTiles.length === 0) return null
  return (
    <Grid item xs={12} sm={10} md={6} style={{ width: '100%' }}>
      <div style={{ margin: '0.25rem' }}>
        <Typography
          variant='overline'
          style={{ fontSize: '1.15rem', color: '#545454' }}
          gutterBottom
        >
          {title}
        </Typography>
        <Grid
          container
          direction='row'
          justifycontent='flex-start'
          alignitems='stretch'
          spacing={1}
        >
          {groupTiles.map(el => (
            <Grid item key={el.title}>
              <FormCard
                icon={el.icon}
                title={el.title}
                link={el.link}
                history={history}
              />
            </Grid>
          ))}
        </Grid>
      </div>
    </Grid>
  )
}

function SkeletonSection () {
  return (
    <Grid item xs={12} sm={10} md={6} style={{ width: '100%' }}>
      <div style={{ margin: '0.25rem' }}>
        <Skeleton variant='text' width={150} height={32} sx={{ mb: 0.5 }} />
        <Grid container direction='row' spacing={1}>
          {[1, 2, 3, 4].map(i => (
            <Grid item key={i}>
              <Skeleton
                variant='rectangular'
                width={TILE_SIZE}
                height={TILE_SIZE}
                sx={{ borderRadius: 1 }}
              />
            </Grid>
          ))}
        </Grid>
      </div>
    </Grid>
  )
}

export default function HomeTabContent ({ sections, allowPage, history, clientModules, loading }) {
  if (loading) {
    return (
      <Grid container spacing={2}>
        {[1, 2, 3].map(i => <SkeletonSection key={i} />)}
      </Grid>
    )
  }

  return (
    <Grid container spacing={2}>
      {sections
        .filter(s => isModuleEnabled(s.permission, clientModules))
        .map((section, i) => (
          <CardGroup
            key={i}
            allowPage={allowPage}
            history={history}
            title={section.title}
            tiles={section.tiles}
          />
        ))}
    </Grid>
  )
}
